import Product from 'src/models/order/product/Product'
import Rental from 'src/models/rental/Rental'
import RentalAwareProduct from 'src/models/order/product/RentalAwareProduct'
import { RentalStatus } from 'src/models/rental/enums/RentalStatus'

export default abstract class RentalBasedProduct
  extends Product
  implements RentalAwareProduct
{
  readonly rental: Rental | null

  constructor(productType: string, rental: Rental | null) {
    super(productType)
    this.rental = rental
  }

  getStatus(): RentalStatus | undefined {
    return this.rental?.status
  }
}
